import React from 'react'
import { useQuery } from '@apollo/client'

import DomainItem from '../DomainItem/DomainItem'
import {
  GET_FAVOURITES,
  GET_SINGLE_NAME,
  NAME_QUERY
} from '../../graphql/queries'
import Loader from '../Loader'

import { isAvailable } from 'utils/registerStatus'

export const DomainInfo = ({ domainState, isFavourite, loading }) => {
  return (
    <DomainItem
      loading={loading}
      domain={domainState}
      isFavourite={isFavourite}
    />
  )
}

const DomainItemContainer = ({ singleName, searchTerm }) => {
  const {
    data: { favourites },
    loading
  } = useQuery(GET_FAVOURITES, {
    name: searchTerm
  })

  return (
    <DomainItem
      loading={loading}
      domain={singleName}
      isFavourite={
        singleName &&
        favourites &&
        favourites.filter(domain => domain.name === singleName.name).length > 0
      }
    />
  )
}

const DomainInfoContainer = ({ searchTerm }) => {
  const { data, loading, error } = useQuery(GET_SINGLE_NAME, {
    variables: {
      name: searchTerm
    }
  })

  const {
    data: { accounts }
  } = useQuery(NAME_QUERY)

  if (loading || !data) return <Loader withWrap />

  if (error) {
    console.error(error)
    return null
  }

  const account = accounts?.[0]
  const { singleName } = data

  const available = isAvailable(account, singleName.label, singleName.nameState)

  return (
    <DomainItemContainer
      {...{ singleName: { ...singleName, available }, searchTerm }}
    />
  )
}

export default DomainInfoContainer
